<template>
  <div class="m-2">
    <div class="row g-0 align-items-center">
      <div
        v-for="(state, index) in ratingArr"
        class="col text-center"
        :key="index">
        <Icon
          :icon="state ? Star : StarOutline"
          class="text-warning"
          width="1.3em"
          height="1.3em"></Icon>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, reactive, ref, watch } from "vue";
import Icon from "./Icon.vue";
import { Star, StarOutline } from "@/utility/icon";

export default defineComponent({
  name: "Rating",
  components: {
    Icon,
  },
  props: {
    value: {
      default: 0,
      type: Number,
    },
  },
  setup(props) {
    const current = ref(0);
    const settings = reactive({
      canEmpty: true,
      max: 5,
      min: 1,
    });

    const setCurrent = (rating: number) => {
      const { max, min, canEmpty } = settings;
      const fixMin = canEmpty ? min - 1 : min;
      const value = rating > max ? max : rating < fixMin ? fixMin : rating;
      current.value = value;
    };

    const ratingArr = computed(() => {
      const arr: boolean[] = [];
      for (let i = settings.min; i <= settings.max; i++) {
        arr.push(i <= current.value ? true : false);
      }
      return arr;
    });

    setCurrent(props.value);
    watch(
      () => props.value,
      (val) => setCurrent(val),
    );

    return {
      current,
      ratingArr,

      // icons
      Star,
      StarOutline,
    };
  },
});
</script>
